var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},_vm._l((this.$store.getters.newsArticles),function(item,key){return _c('NewsArticle',{key:key,attrs:{"title":item.title,"contents":item.contents,"date":item.date,"author":item.author,"tags":item.tags}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }